export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-home-72365ff5ff563fdc8734c0b38a54f687.svg";